"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorySchema = void 0;
exports.StorySchema = {
    "$id": "https://www.redbull.com/schemas/content/stories.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Story",
    "description": "A story is a multimedia article. It allows editors to tell editorial reports or commentaries and can include written text as well as references to images, videos and other content.",
    "properties": {
        "type": {
            "enum": [
                "rrn:content:stories"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:stories:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        },
        "attributes": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "author": {
                    "type": "string",
                    "deprecated": true,
                    "deprecationReason": "The author is replaced by the authorship field. Allowing for multiple authors to be associated with the content and providing more detailed information about the author."
                },
                "callToActions": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/call-to-action.schema.json"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "contentClassificationTerms": {
                    "description": "User defined terms to classify content.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "contextualTitle": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/contextual.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "customProperties": {
                    "description": "Custom properties which can be added to content-resources (E.g. configuration of theme properties, etc.) Note that custom properties are not governed by the content-schema. It is therefore not guaranteed that certain custom properties exist. We also do not migrate custom properties if the schema evolves.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/key-value.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "geoBlockedIn": {
                    "description": "Countries in which the resource is geo-blocked. Resembled through two-letter ISO_3166-1_alpha-2 country codes",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "isPlaceholder": {
                    "description": "Marks a resource as placeholder.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "legacyContentId": {
                    "description": "RB2 content ID.",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "mainPartner": {
                    "description": "Represents the main partner associated with the resource",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/featured-partners.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "planningClassification": {
                    "description": "Content classification rating from the scheduling team.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "A",
                            "B",
                            "C",
                            "D",
                            "E"
                        ]
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "publishedDate": {
                    "description": "The initial published date of the resource. This date is set automatically if the resource is moved from `draft` to `published` state the first time.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "searchTerms": {
                    "description": "A list of search terms which result in a full-match of a given content resource.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "subHeading": {
                    "description": "An additional title of a resource. e.g. films often have subheadings like `Streif - One Hell of a Ride` where `One Hell of a Ride` would be the subHeading",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "teaser": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                },
                "title": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "uriSlug": {
                    "type": "string",
                    "description": "Must be unique across content GUID+language and may be reused for different locales"
                },
                "url": {
                    "description": "If provided, the URL should be used instead of dynamic routes (based on urislug) to link to the content resource (can be used to add resources which are presented outside the RB3 platform)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "usageRestrictions": {
                    "description": "Restrictions describing where the specific resource should NOT be used.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "maturity:NR",
                            "maturity:UR",
                            "no-monetization",
                            "no-stand-alone-display"
                        ]
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "authorship": {
                    "type": "object",
                    "description": "Defines authorship for a story, enabling editors to attribute multiple authors by adding names as text entries or linking to their author profiles.",
                    "$ref": "https://www.redbull.com/schemas/attributes/authorship.schema.json"
                },
                "body": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/paragraph-container.schema.json"
                },
                "contentCategory": {
                    "description": "Specifies the editorial category of your story to support tracking and analyzing content effectiveness and engagement across various formats.",
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "contentHighlight",
                            "contentSeries",
                            "eventEditorial",
                            "eventReport",
                            "howTo",
                            "interview",
                            "listicle",
                            "liveRecap",
                            "other",
                            "portrait",
                            "POV",
                            "teaserTrailer",
                            "news"
                        ]
                    }
                },
                "editorialLastUpdatedDate": {
                    "description": "This date should be set whenever a significant change was made to the story content. This is date is user facing information and will be considered when determining the freshest/newest content.",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json"
                },
                "subType": {
                    "type": "string",
                    "deprecated": true,
                    "deprecationReason": "warn",
                    "enum": [
                        "genericStory",
                        "infographic",
                        "interview",
                        "list",
                        "photoStory",
                        "quiz",
                        "results",
                        "videoStory"
                    ]
                }
            },
            "required": [
                "title",
                "body",
                "teaser",
                "uriSlug"
            ]
        },
        "relationships": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "contentCollections": {
                    "type": "object",
                    "description": "Lists all content-collections that are automatically assigned through the tag tree. Collections are automatically assigned if the `autoAssign` attribute of the collection is set to `true` and one of the tags set on the content resource is also available on the content collection's `mappedTags` relationship.",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/collections.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "displayTags": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "deprecated": true,
                    "deprecationReason": "Display-tags are replaced with content-collections. Use relationship `contentCollections` instead. For further details check out http://bit.ly/2F9w93H",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "embeddedResources": {
                    "type": "object",
                    "description": "All resources embedded in attributes",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "featuredMedia": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/preview-clips.schema.json"
                                    },
                                    {
                                        "type": "object",
                                        "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                                    }
                                ]
                            },
                            "minItems": 1
                        }
                    }
                },
                "headerMedia": {
                    "type": "object",
                    "description": "Content piece shown in the header of another content element (e.g. image shown in the header of a story)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "anyOf": [
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/episode-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/films.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/recap-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/trailer-videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
                                },
                                {
                                    "type": "object",
                                    "$ref": "https://www.redbull.com/schemas/reference/content/video-channels.schema.json"
                                }
                            ]
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "locations": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/locations.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "logo": {
                    "type": "object",
                    "description": "Optional logo for a content piece (e.g. logo for an event-profile)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "master": {
                    "type": "object",
                    "description": "Reference to the master resource holding all translations",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "partners": {
                    "type": "object",
                    "description": "Contains a list of additional partners or sponsors associated with the resource",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "pseudoGroups": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "relatedContents": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "socialMediaImage": {
                    "type": "object",
                    "description": "Image that represents a content resource on social media platforms (og:image)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "tags": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "translatedFrom": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "translations": {
                    "type": "object",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                            }
                        }
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "sponsoredBy": {
                    "type": "object",
                    "description": "The partner who sponsored the creation of this story (financial or other support)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                            }
                        }
                    }
                }
            },
            "required": [
                "featuredMedia"
            ]
        },
        "links": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "object",
                    "string"
                ],
                "description": "A link **MUST** be represented as either: a string containing the link's URL or a link object.",
                "oneOf": [
                    {
                        "description": "A string containing the link's URL.",
                        "type": "string",
                        "format": "uri-reference"
                    },
                    {
                        "type": "object",
                        "required": [
                            "href"
                        ],
                        "properties": {
                            "href": {
                                "description": "A string containing the link's URL.",
                                "type": "string",
                                "format": "uri-reference"
                            },
                            "meta": {
                                "description": "Non-standard meta-information that can not be represented as an attribute or relationship.",
                                "type": "object",
                                "additionalProperties": true
                            }
                        }
                    }
                ]
            }
        },
        "meta": {
            "additionalProperties": true,
            "type": "object",
            "properties": {
                "createdBy": {
                    "description": "User or system that initially created a resource",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "dateCreated": {
                    "description": "DateTime when a resource was created",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "dateUpdated": {
                    "description": "DateTime when a resource was last changed. Every change to a resource results in a new dateUpdated",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "externalReference": {
                    "description": "Reference to external applications (e.g. if the asset was imported)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/external-reference.schema.json",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "foreignKeys": {
                    "description": "Foreign keys of this asset in other systems (e.g. if the asset was imported / links to media asset system)",
                    "type": "array",
                    "deprecated": true,
                    "deprecationReason": "This property will be removed anytime soon. However, the information won't be lost but migrated to `externalReference`",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "language": {
                    "description": "The language the resource is written in",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "locale": {
                    "description": "The locale of the resource.",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "machineTranslated": {
                    "description": "Indicates if the asset was translated by machine/AI.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "published": {
                    "description": "Indicator if resource is published.",
                    "type": "boolean",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "region": {
                    "description": "The region or country the resource was published for (e.g. INT for international region, AT for Austria)",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "spaces": {
                    "description": "Content-spaces a resource is assigned to",
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "status": {
                    "description": "Represents the current lifecycle state of the resource. The status can either be `DRAFT`, `PUBLISHED`, or `UNPUBLISHED`.",
                    "type": "string",
                    "enum": [
                        "DRAFT",
                        "PUBLISHED",
                        "UNPUBLISHED"
                    ],
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                },
                "updatedBy": {
                    "description": "User or system that updated the resource the last time",
                    "type": "string",
                    "inheritedFrom": "https://www.redbull.com/schemas/abstract/content-resource.schema.json"
                }
            }
        }
    },
    "type": "object",
    "required": [
        "type",
        "id",
        "attributes",
        "relationships"
    ]
};
//# sourceMappingURL=data:application/json;base64,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